// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1c7e4dd5","347":"266259b7","409":"ddf3ff75","777":"01d33aef"}[chunkId] + ".chunk.js";
};